// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { VideoProviderListResponse } from '@par/app/core/model/dictionaries.response';

export const getVideoProviderListRequested = createAction('[SELECT VIDEO PROVIDER] Get Video Provider List Requested');
export const getVideoProviderListSucceeded = createAction('[SELECT VIDEO PROVIDER] Get Video Provider List Succeeded', props<{
  response: VideoProviderListResponse
}>());
export const getVideoProviderListFailed = createAction('[SELECT VIDEO PROVIDER] Get Video Provider List Failed');
